import { useEffect, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { getEventStatistics } from "../api/event.api";
import type { EventStatisticsResponse } from "../types/event.types";

export interface UseEventStatisticsState {
  data: EventStatisticsResponse | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useEventStatistics(): UseEventStatisticsState {
  const [data, setData] = useState<EventStatisticsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await getEventStatistics();
      setData(result);
    } catch (fetchError: unknown) {
      setError(getApiErrorMessage(fetchError, "Failed to load event statistics"));
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    loading,
    error,
    refresh: fetchData,
  };
}
